<template>
    <div class="report-nps">
        <div class="top clearfix">
            <div class="title">
                <slot name="title">{{ $root.t('forms-report_component-general_assessment') }}</slot>
                <span class="total-answers">{{ grades.length }} {{ $root.t('forms-report_component-answers') }}</span>
            </div>
            <div v-if="hasAnswers">
                <div class="nps-result">
                    <Thermometer :title="t('nps_score')" :value="npsScore" />
                </div>
            </div>
        </div>
        <div class="distribuition" v-if="hasAnswers">
            <div class="distribuition-row">
                <span class="label" for="">{{ $root.t('forms-report_component-nps_promoter') }}</span>
                <div class="bar">
                    <div
                        class="inside-bar"
                        v-bind:style="{
                            width:
                                gradesNumberToPercent(distributedGrades[9] + distributedGrades[10]) +
                                '%',
                        }"
                    ></div>
                </div>
                <div class="percent">
                    {{ round(gradesNumberToPercent(distributedGrades[9] + distributedGrades[10])) }}%
                </div>
            </div>
            <div class="distribuition-row">
                <span class="label" for="">{{ $root.t('forms-report_component-nps_neutral') }}</span>
                <div class="bar">
                    <div
                        class="inside-bar"
                        v-bind:style="{
                            width:
                                gradesNumberToPercent(distributedGrades[7] + distributedGrades[8]) +
                                '%',
                        }"
                    ></div>
                </div>
                <div class="percent">
                    {{ round(gradesNumberToPercent(distributedGrades[7] + distributedGrades[8])) }}%
                </div>
            </div>
            <div class="distribuition-row">
                <span class="label" for="">{{ $root.t('forms-report_component-nps_detractor') }}</span>
                <div class="bar">
                    <div
                        class="inside-bar"
                        v-bind:style="{
                            width:
                            gradesNumberToPercent(
                                distributedGrades.slice(0, 7).reduce((acc, grade) => acc + grade, 0)
                            ) + '%',
                        }"
                    ></div>
                </div>
                <div class="percent">
                    {{ round(gradesNumberToPercent(distributedGrades.slice(0, 7).reduce((acc, grade) => acc + grade, 0))) }}%
                </div>
            </div>
        </div>
        <div class="no-answers" v-if="!hasAnswers">
            {{ $root.t('forms-report_component-no_answers') }}
        </div>
    </div>
</template>
<script>
import MathHelper from "../../helpers/Math";
import Thermometer from "../../components/thermometer/Thermometer.vue";
export default {
    components: {
        Thermometer,
    },
    props: {
        useGrade: {
            type: Boolean,
            default: false,
        },
        answers: Array,
    },
    computed: {
        grades() {
            let grades = [];
            for (let a in this.answers) {
                let answer = this.answers[a];
                if (this.useGrade) {
                    grades.push(answer.grade);
                } else {
                    grades.push(answer.valueNumber);
                }
            }
            return grades;
        },
        hasAnswers: function () {
            return this.grades.length > 0 ? true : false;
        },
        distributedGrades: function () {
            let distributedGrades = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            for (var i = 0; i < this.grades.length ; i++) {
                let grade = this.round(this.grades[i]);
                distributedGrades[grade]++;
            }
            return distributedGrades;
        },
        npsScore() {
            const totalResponses = this.grades.length;
            const promoters = this.distributedGrades[9] + this.distributedGrades[10];
            const detractors = this.distributedGrades.slice(0, 7).reduce((acc, grade) => acc + grade, 0); // 0 to 6
            const promotersPercent = (promoters / totalResponses) * 100;
            const detractorsPercent = (detractors / totalResponses) * 100;
            return this.round(promotersPercent - detractorsPercent);
        }
    },
    methods: {
        gradesNumberToPercent: function (number) {
            return (number / this.grades.length) * 100;
        },
        round: MathHelper.round,
    },
};
</script>
